import { jsx as m } from "react/jsx-runtime";
import * as r from "react";
import { c } from "../index-Cu0xwYjD.js";
import { ErrorContext as n } from "../Context/ErrorContext.js";
const p = "_textarea_pw5wv_1", i = "_textareaWithError_pw5wv_21", t = {
  textarea: p,
  textareaWithError: i
}, f = r.forwardRef((e, a) => {
  const { className: o, ...s } = e, { errors: x } = r.useContext(n);
  return /* @__PURE__ */ m(
    "textarea",
    {
      className: c(t.textarea, o, {
        [t.textareaWithError]: x.length > 0
      }),
      ref: a,
      ...s
    }
  );
});
f.displayName = "Textarea";
export {
  f as Textarea
};
